import { render } from "./Movimientos.vue?vue&type=template&id=2cc89d91&scoped=true"
import script from "./Movimientos.vue?vue&type=script&lang=js"
export * from "./Movimientos.vue?vue&type=script&lang=js"

import "./Movimientos.vue?vue&type=style&index=0&id=2cc89d91&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc89d91"]])

export default __exports__